import React, { PureComponent } from 'react';

import { PropTypes } from 'mobx-react';

export default class Drag extends PureComponent {
  initialCursorPosition = null;

  static propTypes = {
    children: PropTypes.object,
    onCueMove: PropTypes.func
  };

  render() {
    const { children } = this.props;

    const handlers = {
      onMouseDown: this.onStart,
      onTouchStart: this.onStart
    };

    return React.cloneElement(children, { ...handlers });
  }

  onCueMove = (event) => {
    const { clientX: mouseX, targetTouches } = event;
    const { onCueMove } = this.props;

    const positionX =
      mouseX || (targetTouches && targetTouches[0].clientX) || 0;

    if (this.initialCursorPosition !== null) {
      const pixelsMoved = positionX - this.initialCursorPosition;

      onCueMove && onCueMove(pixelsMoved, positionX);
    }

    this.initialCursorPosition = positionX;
  };

  onStart = (event) => {
    if (event.type === 'touchstart') {
      window.addEventListener('touchmove', this.onCueMove);
      window.addEventListener('touchend', this.onEnd);
    } else if (event.nativeEvent.which === 1) {
      window.addEventListener('mousemove', this.onCueMove);
      window.addEventListener('mouseup', this.onEnd);
    }

    event.stopPropagation();
  };

  onEnd = () => {
    this.initialCursorPosition = null;

    window.removeEventListener('mousemove', this.onCueMove);
    window.removeEventListener('touchmove', this.onCueMove);

    window.removeEventListener('mouseup', this.onEnd);
    window.removeEventListener('touchend', this.onEnd);
  };
}
